import { Container } from '../../../../../components/container/container';
import { Loader } from '../../../../../components/loader/loader';
import { Page } from '../../../../../components/page/page';
import s from './create-tree.module.css';
import { TreeName } from './tree-name/tree-name';
import { TreeNode } from './tree-node/tree-node';
import { TreeStructure } from './tree-structure/tree-structure';
import { useCreateTree } from './use-create-tree';

export const CreateTree = () => {
  const { id, t, isLoadingFetch } = useCreateTree();

  return (
    <Page className={s.page}>
      {isLoadingFetch && <Loader />}
      <h2 className={s.title}>{t(id ? 'Изменить дерево' : 'Создать дерево')}</h2>
      <Container className={s.container}>
        <Container className={s.containerLeft}>
          <TreeName />
          <TreeNode />
        </Container>
        <TreeStructure />
      </Container>
    </Page>
  );
};
